import React, {useEffect, useState} from 'react'
import { Form } from 'react-bootstrap'
import { uData, updateUser } from '../../api/api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import {DeleteForever } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import Cookie from 'react-cookies';
const UserProfile = () => {
    const user = useSelector(state => state.user.payload);
	const navigate = useNavigate()
	const [data, setData ] = useState(user);
	const [password, setPassword] = useState('');
	const [image, setImage] = useState(user.img);
	const [imageStatus, setImageStatus] = useState(false);

    const handleChange = (e) => {
        
        setData({ ...data, [e.target.name] : e.target.value});

    }

    const handleSubmit = async (e) => {
      e.preventDefault()
	//   window.start_load();
	  let formId = document.getElementById('newUser');
      const formData = new FormData(formId);
	  formData.append('memberId', user.memberId);
	  const process = async () => {
        if(typeof(image[0]) === 'object'){
            formData.append('file', image[0]);
            formData.append('imageStatus', 1);
        }else{
          formData.append('imageStatus', 0);
        }
		// console.log(formData);
		const response = await updateUser(formData);
		if(response.success){
			// Swal.fire('Success', response.message, 'success');///
			Swal.fire({
				title: 'Successful',
				icon:"success",
				text: response.message,
				closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
			})
			// uData(navigate, token);
			uData(navigate, Cookie.load('token'));
			setImage(user.image);
			setData(user);
		}else{
			// Swal.fire('Failed', response.message, 'error')
			Swal.fire({
				title: 'Failed',
				icon:"error",
				text: response.message,
				// showCloseButton: true,
				showConfirmButton: false,
				timer: 5000
				// closeButtonHtml: `<button className=" btn btn-color w-25"> Close </button>` 
			})
		}
	  }
		process();
    }

	useEffect(() => {
		document.title = 'Member Profile | Bida Sport Club'

	}, [])
	useEffect(() => {
		setImage(user.img);
		setData(user);
		user.image && setImageStatus(true)
		// console.log(user);
	}, [user])
  return (
    <div className='m-1 px-2 py-5'
	style={{ 
		backgroundColor: 'whitesmoke',
		height: '99vh'
	 }}
	>
		<h4><b className=" mb-5">Member Profile </b></h4> 
      <div className="card">
		<div className="card-body">
			<form action="" id="newUser"
			onSubmit={handleSubmit}
			>
				<div className="row">
					<div className="col-md-6 border-right">
						<b className="text-muted">Personal Information</b>
						{
							 !imageStatus && 
							 <div className='d-flex justify-content-center align-items-center'>
                        <input type="file"  
                        onChange={(e) => {
                            // let media = [...newsImages.media,...e.target.files]
                          setImage(e.target.files)
						  setImageStatus(true)
                            // dispatch(addProduct({media}))
                        }}
                        style={{display:"none"}} placeholder="Type here" name='file' className="form-control" id="uploadImages"
                        />
                        <label  htmlFor='uploadImages' className='upload-images-label d-flex justify-content-center align-items-center' style={{
                                display: "block",
                                width: "90%",
                                height:140,
                                borderStyle:'dashed',
                                borderColor:'GrayText',
                                borderWidth:0.5,
                                borderRadius:5,
                            }
                        }>
                            <span style={{fontSize:16}}> Click to Add  Member Image</span>
                        </label>
                        </div>
						}
						{
							imageStatus && 
							<div className='products-container d-flex justify-content-start align-items-center m-2'>
                            
                                        <div className='product-container d-flex-column mx-2 justify-content-center align-items-center' style={{
                                            cursor: "pointer",
                                            borderRadius:5,
                                            borderWidth:1,
                                            borderColor:"#e0e2e3",
                                }} >
                                        <img
                                            src={ typeof(image[0]) === 'object' ? URL.createObjectURL(image[0]) : image}
                                            width={150}
                                            height={100}
                                        />
                                        {/* <div className='delete-product d-flex justify-content-center align-items-center' style={{color:'#a50f0f'}} onClick={()=>{
                                            setNewsImages(newsImages.filter((_,ind)=> ind != index))
                                        }}>
                                            <i className="material-icons md-delete_forever"></i>
                                        </div> */}
                                        {
											user.image  === '' &&
											<DeleteForever
											className='d-flex justify-content-center align-self-center justify-contents-center'
											color='error'
											onClick={() => {
												setImageStatus(false)
												setImage('')
											}
											}
											/>
										}
                                </div>
                            
                        </div>
						}
						<div className="form-group">
							<label for="" className="control-label">Name</label>
							<input
                            value={data.name}
							onChange={handleChange}
							type="text" name="name" className="form-control form-control-sm" required />
						</div>
						<div className="form-group">
							<label className="control-label">Email</label>
							<input 
                            value={data.email}
							onChange={handleChange}
							type="email" className="form-control form-control-sm" name="email"  />
							<small id="#msg"></small>
						</div>
						<div className="form-group">
							<label for="" className="control-label">Phone</label>
							<input 
                            value={data.phone}
							onChange={handleChange}
							type="text" name="phone" className="form-control form-control-sm"  />
						</div>
						<div className="form-group">
							<label className="control-label">Username</label>
							<input 
                            value={data.username}
							onChange={handleChange}
							type="text" className="form-control form-control-sm" name="username"  />
							
						</div>
						<div className="form-group">
							<label className="control-label">Address </label>
							<input 
                            value={data.address}
							onChange={handleChange}
							type="text" className="form-control form-control-sm" name="address" />
							
						</div>
					</div>
					<div className="col-md-6">
					<b className="text-muted">Other Details </b>
					<div className="form-group">
							<label className="control-label">Occupation</label>
							<input 
                            value={data.occupation}
							onChange={handleChange}
							type="text" className="form-control form-control-sm" name="occupation"  />
							
						</div>
						<div className="form-group">
							<label className="control-label">Office Address </label>
							<input 
                            value={data.office}
							onChange={handleChange}
							type="text" className="form-control form-control-sm" name="office" />
							
						</div>
					<div className="form-group">
							<label for="" className="control-label">Gender</label>
							<Form.Select 
                            value={data.gender}
							onChange={handleChange}
							size='sm' name="gender" id="gender" className="form-control">
								<option value="" >Select Gender ... </option>
								<option value="1" >Male </option>
								<option value="0" >Female</option>
							</Form.Select>
							<small><i></i></small>
						</div>
						<div className="form-group">
							<label for="" className="control-label">Select Unit</label>
							<Form.Select 
                            value={data.unit}
							onChange={handleChange}
							size='sm' name="unit" id="unit" className="form-control">
								<option value="" >Select Member Unit... </option>
								<option value="Badminton" >Badminton</option>
								<option value="Gym" >Gym</option>
								<option value="Table Tennis"> Table Tennis </option>
								<option value="Tennis"> Tennis </option>
							</Form.Select>
							<small><i></i></small>
						</div>
						<div className="form-group">
							<label className="control-label">Position </label>
							<Form.Select 
                            value={data.position}
							onChange={handleChange}
							size='sm' name="position" id="position" className="form-control">
								<option value="" >Select Position ... </option>
								<option value="president" >President </option>
								<option value="vice president" >Vice President</option>
								<option value="secretary" >Secretary </option>
								<option value="treasurer" >Treasurer </option>
								<option value="financial secretary" >Financial Secretary </option>
								<option value="assistant secretary" >Assistant Secretary</option>
								<option value="pro" >Public Relation Officer </option>
								<option value="captain" >Unit Captain </option>
								
								<option value="member" >Regular Member </option>
							</Form.Select>
						</div>
						<div className="form-group">
							<label className="control-label">Membership ID</label>
							<input 
                            value={data.memberId}
                            disabled
							onChange={handleChange}
							type="text" className="form-control form-control-sm" name="memberId"/>
							
						</div>
						{/* <div className="form-group">
							<label for="" className="control-label">Account Status</label>
							<Form.Select 
							onChange={handleChange}
							size='sm' name="status" id="type" className="form-control">
								<option value="" >Select Status ... </option>
								<option value="1" >Active </option>
								<option value="0" >Disabled</option>
							</Form.Select>
							<small><i></i></small>
						</div> */}
					</div>
				</div>
				<hr />
				<div className="col-lg-12 text-right justify-content-center d-flex">
					 <button className="btn btn-danger btn-lg" type="button" 
					 onClick={()=> {
						navigate('/dashboard');
					 }}
					 style={{ width: '120px' }}
					 >Cancel</button>
					 <button
					 
					 className="btn btn-color btn-lg ms-2"
					  style={{ width: '120px' }}
					 >Update</button> 
				</div>
			</form>
		</div>
	</div>
    </div>
  )
}

export default UserProfile